import { Chip } from "@dash/form";
import { useTheme } from "@emotion/react";

type Props = {
  isArchived: boolean;
  isFulfilled: boolean;
};

export const CartStatusChips: React.FC<Props> = ({ isArchived, isFulfilled }) => {
  const theme = useTheme();

  if (isFulfilled) {
    return (
      <Chip color={theme.colors.primary} variant="secondary">
        Zrealizowany
      </Chip>
    );
  }

  const archive = isArchived
    ? { color: theme.colors.default, variant: "outline" as const, label: "Zarchiwizowany" }
    : { color: theme.colors.success, variant: "secondary" as const, label: "Aktywny" };

  return (
    <Chip color={archive.color} variant={archive.variant}>
      {archive.label}
    </Chip>
  );
};
